// extracted by mini-css-extract-plugin
module.exports = {"buttonSecondary":"ButtonSecondary_buttonSecondary__1_n_P"};